import MDB from '../marketingdb';

//Direct copy of MDB.loadResourceString(...)
//loadResourceString is not guaranteed to be available yet at calltime
//The script setting MDB.Texts is always the first script to execute on page load
export default (resourceName) => {
    if (!MDB.hasOwnProperty('Texts') || MDB.Texts.Length === 0) {
        console.warn('Resources not loaded!');
        return resourceName;
    } else {
        var res = MDB.Texts[resourceName] || '';
        if (!res && !MDB.Texts.hasOwnProperty(resourceName)) {
            console.warn('Resources contain no string "' + resourceName + '"!');
        }
        return res;
    }
};